import * as React from "react";
import { Link } from "react-router-dom";

const NavItem = props => (
  <li className={props.active ? "active" : ""}>
    <Link to={props.to}>{props.children}</Link>
  </li>
);

export default NavItem;



// WEBPACK FOOTER //
// ./src/routes/StaticPages/components/NavItem.tsx